import * as React from "react";
import { useDispatch } from "@teamprevent/admin-redux";
import { AxiosError } from "axios";
import { Confirm, Dropdown, Button } from "semantic-ui-react";

import { TaskModel } from "@teamprevent/common/task/taskActions/models";
import { toast } from "@teamprevent/common/toasts";

import { createVideoMeeting } from "../actions";

import { CreateVideoMeetingButton } from "./CreateVideoMeetingButton";
import { UnableToBookVideoConsultationButton } from "./UnableToBookVideoConsultationButton";

interface Props {
    task: TaskModel;
    creatingMeeting: boolean;
    setCreatingMeeting: (creating: boolean) => void;
}

export const VideoMeetingsLower: React.FunctionComponent<Props> = (props: Props) => {
    const [confirmationModalOpen, setConfirmationModalOpen] = React.useState<boolean>(false);

    const onHandleCreateMeeting = async () => {
        if (props.task.teamsMeetingLink) {
            setConfirmationModalOpen(true);
        } else {
            await handleCreateMeeting();
        }
    };

    const onHandleCreateMeetingCancel = () => setConfirmationModalOpen(false);

    const dispatch = useDispatch();
    const handleCreateMeeting = async () => {
        try {
            props.setCreatingMeeting(true);
            toast.info("Creating video meeting...");
            await dispatch(createVideoMeeting(props.task.caseId, props.task.id));
            toast.success("Teams video meeting has been created");
        } catch (ex) {
            setConfirmationModalOpen(false);
            const axiosError = ex as AxiosError;
            toast.error("Error has occurred:" + axiosError.message);
            toast.info("Re-login might be required in order to create new meeting");
        } finally {
            setConfirmationModalOpen(false);
            props.setCreatingMeeting(false);
        }
    };

    if (props.task.completed || props.task.cancelled) {
        return null;
    }

    if (props.task.isVideoBookAppointmentTask) {
        return (
            <div className="video-meetings-left">
                <UnableToBookVideoConsultationButton task={props.task} />
            </div>
        );
    }

    if (props.task.isVideoAppointmentTask) {
        return (
            <>
                <div className="video-meetings-left">
                    <Dropdown className="icon" labeled as={Button} text="Unable to Carry Out" icon="add" pointing="left" direction="right" upward>
                        <Dropdown.Menu>
                            <CreateVideoMeetingButton task={props.task} handleCreateMeeting={onHandleCreateMeeting} creatingMeeting={props.creatingMeeting} />
                            <Confirm
                                open={confirmationModalOpen}
                                // eslint-disable-next-line max-len
                                content="If you have already a Video Consultation booked, this will cancel it and create a new video meeting. Are you sure you wish to continue?"
                                cancelButton="No"
                                confirmButton="Yes"
                                onCancel={onHandleCreateMeetingCancel}
                                onConfirm={handleCreateMeeting}
                            />
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </>
        );
    }

    return null;
};
